<template>
  <a-spin :tip="loadingTip" :spinning="isloading">
    <div>
      <div class>
        <a-form :form="form" @submit="handleSubmit">
          <a-form-item label="姓名" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
            <a-input
              placeholder="请输入真实姓名"
              v-decorator="[
          'name',
          {rules: [{ required: true, message: '请输入真实姓名!' }],initialValue:info.name}
        ]"
            ></a-input>
          </a-form-item>
          <a-form-item label="性别" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
            <a-radio-group
              @change="onChange"
              v-decorator="[
          'sex',
          {rules: [],initialValue:info.sex}
        ]"
            >
              <a-radio :value="1">男</a-radio>
              <a-radio :value="2">女</a-radio>
            </a-radio-group>
          </a-form-item>
          <a-form-item label="民族" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
            <a-input
              placeholder="请输入民族"
              v-decorator="[
          'nation',
          {rules: [{ required: false, message: '请输入民族!' }],initialValue:info.nation}
        ]"
            ></a-input>
          </a-form-item>
          <a-form-item label="身份证号" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
            <a-input
              placeholder="请输入身份证号"
              v-decorator="[
          'idCard',
          {rules: [{ required: true, message: '请输入身份证号!' }],initialValue:info.idCard}
        ]"
            ></a-input>
          </a-form-item>
          <a-form-item label="手机号" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
            <a-input
              placeholder="请输入手机号"
              v-decorator="[
          'telephone',
          {rules: [{ required: true, message: '请输入手机号!' }],initialValue:info.telephone}
        ]"
            ></a-input>
          </a-form-item>
          <!-- <a-form-item label="密码" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
            <a-input
              placeholder="请输入密码"
              v-decorator="[
          'password',
          {rules: [{ required: true, message: '请输入密码!' }],initialValue:info.password}
        ]"
            ></a-input>
          </a-form-item>
          <a-form-item label="确认密码" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
            <a-input
              placeholder="请再次输入密码"
              v-decorator="[
          'password',
          {rules: [{ required: true, message: '请再次输入密码!' }],initialValue:info.password}
        ]"
            ></a-input>
          </a-form-item>-->
          <a-form-item label="户籍" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
            <a-input
              placeholder="请输入户籍"
              v-decorator="[
          'census',
          {rules: [{ required: false, message: '请输入户籍!' }],initialValue:info.census}
        ]"
            ></a-input>
          </a-form-item>
          <a-form-item label="所报院校" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
            <a-input
              placeholder="请输入所报院校"
              v-decorator="[
          'school',
          {rules: [{ required: true, message: '请输入所报院校!' }],initialValue:info.school}
        ]"
            ></a-input>
          </a-form-item>
          <a-form-item label="所报专业" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
            <a-input
              placeholder="请输入所报专业"
              v-decorator="[
          'specialty',
          {rules: [{ required: true, message: '请输入所报专业!' }],initialValue:info.specialty}
        ]"
            ></a-input>
          </a-form-item>
          <a-form-item label="所报层次" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
            <a-input
              placeholder="请输入所报层次"
              v-decorator="[
          'education',
          {rules: [{ required: true, message: '请输入所报层次!' }],initialValue:info.education}
        ]"
            ></a-input>
          </a-form-item>
          <a-form-item label="毕业院校" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
            <a-input
              placeholder="请输入毕业院校"
              v-decorator="[
          'graduatedSchool',
          {rules: [{ required: false, message: '请输入毕业院校!' }],initialValue:info.graduatedSchool}
        ]"
            ></a-input>
          </a-form-item>
          <a-form-item label="所学专业" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
            <a-input
              placeholder="请输入所学专业"
              v-decorator="[
          'leanSpecialty',
          {rules: [{ required: false, message: '请输入所学专业!' }],initialValue:info.leanSpecialty}
        ]"
            ></a-input>
          </a-form-item>
          <a-form-item label="工作单位" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
            <a-input
              placeholder="请输入工作单位"
              v-decorator="[
          'company',
          {rules: [{ required: false, message: '请输入工作单位!' }],initialValue:info.company}
        ]"
            ></a-input>
          </a-form-item>
          <a-form-item label="单位电话" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
            <a-input
              placeholder="请输入单位电话"
              v-decorator="[
          'companyTelephone',
          {rules: [{ required: false, message: '请输入单位电话!' }],initialValue:info.companyTelephone}
        ]"
            ></a-input>
          </a-form-item>
          <!-- <a-form-item label="联系方式" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
            <a-input
              placeholder="请输入联系方式"
              v-decorator="[
          'contactInformation',
          {rules: [{ required: false, message: '请输入联系方式!' }],initialValue:info.contactInformation}
        ]"
            ></a-input>
          </a-form-item>-->
          <a-form-item label="紧急联系人号码" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
            <a-input
              placeholder="请输入紧急联系人号码"
              v-decorator="[
          'crashTelephone',
          {rules: [{ required: false, message: '请输入紧急联系人号码!' }],initialValue:info.crashTelephone}
        ]"
            ></a-input>
          </a-form-item>
          <a-form-item label="本人QQ" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
            <a-input
              placeholder="请输入本人QQ"
              v-decorator="[
          'qqCode',
          {rules: [{ required: false, message: '请输入本人QQ!' }],initialValue:info.qqCode}
        ]"
            ></a-input>
          </a-form-item>
          <!-- <a-form-item label="本人微信" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
            <a-input
              placeholder="请输入本人微信"
              v-decorator="[
          'wechatCode',
          {rules: [{ required: false, message: '请输入本人微信!' }],initialValue:info.wechatCode}
        ]"
            ></a-input>
          </a-form-item>-->
          <a-form-item label="一寸照片" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
            <a-upload
              :action="$api.file.uploadFile"
              listType="picture-card"
              :fileList="fileList"
              @preview="handlePreview"
              @change="handleChange"
            >
              <div v-if="fileList.length < 1">
                <a-icon type="plus" />
                <div class="ant-upload-text">Upload</div>
              </div>
            </a-upload>
          </a-form-item>
          <a-form-item label="身份证照片" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
            <a-upload
              :action="$api.file.uploadFile"
              listType="picture-card"
              :fileList="idCardfileList"
              @preview="handlePreview"
              @change="handleChange"
            >
              <div v-if="idCardfileList.length < 1">
                <a-icon type="plus" />
                <div class="ant-upload-text">Upload</div>
              </div>
            </a-upload>
          </a-form-item>
          <a-form-item label="毕业证照片" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
            <a-upload
              :action="$api.file.uploadFile"
              listType="picture-card"
              :fileList="graduatefileList"
              @preview="handlePreview"
              @change="handleChange"
            >
              <div v-if="graduatefileList.length < 1">
                <a-icon type="plus" />
                <div class="ant-upload-text">Upload</div>
              </div>
            </a-upload>
          </a-form-item>
          <a-form-item
            label="报名表"
            class="is-required"
            :label-col="{ span: 5 }"
            :wrapper-col="{ span: 19 }"
          >
            <a-button type="link" :href="info.registration">点击查看</a-button>
          </a-form-item>
          <!-- <a-form-item label="上传图片" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
            <a-upload
              :action="$api.file.uploadFile"
              listType="picture-card"
              :fileList="fileList"
              @preview="handlePreview"
              @change="handleChange"
            >
              <div v-if="fileList.length < 1">
                <a-icon type="plus" />
                <div class="ant-upload-text">Upload</div>
              </div>
            </a-upload>
            <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
              <img alt="example" style="width: 100%" :src="previewImage" />
            </a-modal>
          </a-form-item>-->
          <!-- <a-form-item :wrapper-col="{ span: 19, offset: 5 }">
            <pxkeji-btn name="保存" type="primary" htmlType="submit" />
            <pxkeji-btn name="取消" type="default" @click="cancelClick" class="cancelBtn" />
          </a-form-item>-->
        </a-form>
      </div>
    </div>
  </a-spin>
</template>

<script>
var that;
export default {
  props: {
    infos: {
      type: Object,
      default: () => {}
    },
    id: 0
  },
  data() {
    return {
      form: this.$form.createForm(this),
      info: {
        number: "",
        startTime: "",
        endTime: ""
      },
      servicelists: [],
      serviceNames: [],
      serviceIds: [],
      goodlists: [],
      goodNames: [],
      goodIds: [],
      isloading: false,
      loadingTip: "加载中...",
      fileList: [],
      idCardfileList: [],
      graduatefileList: [],
      previewVisible: false,
      previewImage: "",
      uploadImg: [],
      service: {
        //服务项目
        visible: false
      },
      good: {
        //擅长项目
        visible: false
      },
      schedule: {
        //排班
        visible: false,
        list: ""
      }
    };
  },
  components: {},
  mounted() {
    this.$nextTick(function() {
      that = this;
      if (this.id) {
        //编辑
        this.getInfo();
      }
      if (!this.type) {
        this.dis = true;
      }
    });
  },
  methods: {
    /**取消 */
    cancelClick() {
      this.$emit("callbackMethod");
    },
    /**数据回显 */
    getInfo() {
      this.isloading = true;
      this.$api.enrollment
        .getById(this.id)
        .then(res => {
          this.isloading = false;
          if (res.errorCode == this.$msg.responseCode.success) {
            this.info = res.data;
            this.info.sex = res.data.gender == "男" ? 1 : 2;
            console.log(res.data);
            if (res.data.oneinchPhoto.length > 0) {
              var pics = res.data.oneinchPhoto.split(",");
              for (var i = 0; i < pics.length; i++) {
                this.fileList.push({
                  uid: i,
                  name: "一寸照片" + (i + 1) + ".png",
                  status: "done",
                  url: pics[i]
                });
              }
            }
            if (res.data.idCardPhoto.length > 0) {
              var idpics = res.data.idCardPhoto.split(",");
              for (var i = 0; i < idpics.length; i++) {
                this.idCardfileList.push({
                  uid: i,
                  name: "身份证照片" + (i + 1) + ".png",
                  status: "done",
                  url: idpics[i]
                });
              }
            }
            if (res.data.graduatePhoto.length > 0) {
              var grapics = res.data.graduatePhoto.split(",");
              for (var i = 0; i < grapics.length; i++) {
                this.graduatefileList.push({
                  uid: i,
                  name: "身份证照片" + (i + 1) + ".png",
                  status: "done",
                  url: grapics[i]
                });
              }
            }
            this.info.registration = res.data.registrationForm;
            if (res.data.school != "") {
              this.info.school = JSON.parse(res.data.school).itemName;
            }
             if (res.data.specialty != "") {
              this.info.specialty = JSON.parse(res.data.specialty).itemName;
            }
          } else {
            this.error(res.errorMsg);
          }
        })
        .catch(() => {
          this.isloading = false;
        });
    },
    //性别选择
    onChange(e) {
      // console.log(e.target.value)
      this.info.sex = e.target.value;
    },
    /**选择可服务项目 */
    choseService() {
      this.service.visible = true;
    },
    getservice(data) {
      this.service.visible = false;
      this.servicelists = [];
      this.serviceNames = [];
      this.serviceIds = [];
      data.forEach(function(item, index) {
        that.servicelists.push({
          name: item.name,
          id: item.id,
          img: item.img
        });
        that.serviceNames.push(item.name);
        that.serviceIds.push(item.id);
      });
      that.info.serviceNames = this.serviceNames.join(",");
      this.form.setFieldsValue({
        serviceNames: this.serviceNames.join(",")
      });
    },
    /**选择擅长 */
    choseGood() {
      this.good.visible = true;
    },
    getgood(data) {
      this.good.visible = false;
      this.goodlists = [];
      this.goodNames = [];
      this.goodIds = [];
      data.forEach(function(item, index) {
        that.goodlists.push({
          name: item.name,
          id: item.id
        });
        that.goodNames.push(item.name);
        that.goodIds.push(item.id);
      });
      that.info.goodNames = this.goodNames.join(",");
      this.form.setFieldsValue({
        goodNames: this.goodNames.join(",")
      });
    },
    /**查看排班 */
    handleSchedule() {
      this.schedule.visible = true;
    },
    getschedule(data) {
      this.schedule.visible = false;
      var schedules = {};
      data.forEach(function(item, index) {
        var thisData = {};
        thisData["am"] = item.am;
        thisData["pm"] = item.pm;
        schedules[item.time] = thisData;
      });
      this.schedule.list = JSON.stringify(schedules);
      //console.log(schedules);
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          this.uploadImg = [];
          this.fileList.forEach(function(item, index) {
            that.uploadImg.push(item.response.data.path);
          });
          if (this.id) {
            //修改
            this.isloading = true;
            this.loadingTip = "保存中...";




            this.$api.member.expert
              .updateById(
                that.id,
                that.uploadImg.join(","),
                this.info.sex == 1 ? "男" : "女",
                values.employedTime,
                values.appointmentCount,
                values.appointPrice,
                values.caseCount,
                values.supportCount,
                that.serviceIds.join(","),
                that.goodIds.join(","),
                values.introduce,
                that.schedule.list ? that.schedule.list : "",
                values.recommend
                  ? this.$commen.changeBooleanInt(values.recommend)
                  : this.$commen.changeBooleanInt(this.info.recommend)
              )
              .then(res => {
                this.isloading = false;
                if (res.errorCode == this.$msg.responseCode.success) {
                  this.$message.success(res.errorMsg);
                  this.$emit("callbackMethod");
                } else {
                  this.error(res.errorMsg);
                }
              })
              .catch(() => {
                this.isloading = false;
              });
          } else {
            //新增
            this.isloading = true;
            this.loadingTip = "保存中...";
            this.$api.user
              .saveUser(
                1,
                values.realName,
                this.info.sex == 1 ? "男" : "女",
                values.idCard,
                values.telephone ? values.telephone : "",
                values.password,
                values.address,
                values.disabledCard,
                values.administration ? values.administration : "",
                values.company ? values.company : "",
                values.email ? values.company : ""
              )
              .then(res => {
                this.isloading = false;
                if (res.errorCode == this.$msg.responseCode.success) {
                  this.$message.success(res.errorMsg);
                  this.$emit("callbackMethod");
                  //this.form.resetFields();
                } else {
                  this.$message.error(res.errorMsg);
                }
              })
              .catch(() => {
                this.isloading = false;
              });
          }
        }
      });
    },

    onRangeChange(value, dateString) {
      this.info.startTime = dateString[0];
      this.info.endTime = dateString[1];
    },
    onCheckboxChange(e) {
      this.info.checked = e.target.checked;
    },
    handleCancel() {
      this.previewVisible = false;
    },
    beforeUpload(file, fileList) {
      var isJPGPNG = false;
      if (file.type === "image/jpeg" || file.type === "image/png") {
        isJPGPNG = true;
      } else {
        isJPGPNG = false;
        this.$message.error("只能上传jpg/png格式的文件!");
      }
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("文件不能超过2MB!");
      }
      return isJPGPNG && isLt2M;
    },
    handlePreview(file) {
      this.previewImage = file.url || file.thumbUrl;
      this.previewVisible = true;
    },
    handleChange(info) {
      if (info.file.status) {
        this.fileList = info.fileList;
      }
    },
    error(msg) {
      this.$error({
        title: "提示",
        content: msg == undefined ? "服务器异常" : msg,
        okText: "返回",
        centered: true,
        onOk() {
          that.$emit("callbackMethod");
        }
      });
    }
  }
};
</script>
<style>
.scheduleBtn {
  color: #1890ff;
  cursor: pointer;
}
</style>